import type { TagProps } from "antd/es/tag"

export const AttachmentTags: Record<string, TagProps["color"]> = {
  ["Milestone"]: "cyan",
  ["Financial Item"]: "green",
  ["Invoice"]: "orange"
}
